const WINDOWS_DRIVE_REGEX = /^[A-Za-z]:/;

const unquote = (text) => text.trim().replace(/^["']|["']$/g, '');

// Un texte est traité comme un chemin (et non comme un filtre par nom) s'il
// commence par une lettre de lecteur (O:) ou contient un séparateur.
export const looksLikeMediaPath = (text) => {
  if (!text) return false;
  const value = unquote(text);
  return (
    WINDOWS_DRIVE_REGEX.test(value) ||
    value.includes('\\') ||
    value.includes('/')
  );
};

// "A/B/C" -> ['', 'A', 'A/B'] : les dossiers à charger pour afficher C.
export const getAncestorPaths = (path) => {
  if (!path) return [];
  const parts = path.split('/');
  return parts.map((_, index) => parts.slice(0, index).join('/'));
};

export const toWindowsPath = (path) =>
  `O:\\${(path || '').split('/').join('\\')}`;

export const joinMediaPath = (folderPath, name) =>
  folderPath ? `${folderPath}/${name}` : name;

export const getResolvePathErrorMessage = (error, rawPath) => {
  const status = error?.response?.status;
  const detail = error?.response?.data?.error || '';
  if (status === 404) return `Dossier introuvable : ${rawPath}`;
  if (status === 400 && /ambiguous/i.test(detail)) {
    return `Chemin ambigu : plusieurs dossiers correspondent à ${rawPath} (seules les majuscules diffèrent)`;
  }
  if (status === 400) return `Chemin invalide : ${rawPath}`;
  return "Erreur lors de l'ouverture du chemin";
};

// Formats que le navigateur sait afficher. Les autres (PSD, TIFF, AI, MKV...)
// ne sont proposés qu'au téléchargement, sans être chargés pour rien.
const PREVIEW_KINDS = {
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
  gif: 'image',
  svg: 'image',
  webp: 'image',
  mp4: 'video',
  webm: 'video',
  mov: 'video',
  pdf: 'pdf',
};

export const getPreviewKind = (format) =>
  PREVIEW_KINDS[String(format || '').toLowerCase()] ?? null;

// Au-delà, le fichier n'est ni prévisualisé ni téléchargé depuis Prométhée
// (le back le refuse aussi, en 413) : chaque transfert occupe un worker du
// back. L'utilisateur le récupère directement sur le disque média.
export const MEDIA_PREVIEW_MAX_BYTES = 20 * 1024 * 1024;
export const MEDIA_PREVIEW_MAX_LABEL = '20 Mo';

export const isTooLargeForPreview = (file) =>
  Number(file?.size_bytes) > MEDIA_PREVIEW_MAX_BYTES;

// Formats pour lesquels le back produit une miniature (thumbnail-worker).
const THUMBNAIL_FORMATS = new Set(['jpg', 'jpeg', 'png', 'gif']);

export const canHaveThumbnail = (file) =>
  THUMBNAIL_FORMATS.has(String(file?.media_format || '').toLowerCase()) &&
  !isTooLargeForPreview(file);

// Tris proposés en mode « Grandes icônes » (sans en-têtes de colonnes).
export const ICONS_SORT_OPTIONS = [
  { value: 'name', label: 'Nom (A → Z)' },
  { value: '-name', label: 'Nom (Z → A)' },
  { value: '-created_at', label: "Date d'ajout (récent d'abord)" },
  { value: 'created_at', label: "Date d'ajout (ancien d'abord)" },
  { value: '-size', label: 'Poids (lourd d’abord)' },
  { value: 'size', label: 'Poids (léger d’abord)' },
];
